
        <div class="site-header-placeholder"></div>
        <header class="site-header" [class.moveOut]="moveOut">
            <p class="site-title">
                <a href="/">
                    Valeria Pajares Dominguez
                </a>
            </p>
            <div class="header-menu">
              <ul class="menu">
                <li class="menu-item">
                  <a [routerLink]="['']" [routerLinkActive]="['current-menu-item']" [routerLinkActiveOptions]="{ exact: true }">Work</a>
                </li>
                <li class="menu-item">
                  <a [routerLink]="['links']" [routerLinkActive]="['current-menu-item']" [routerLinkActiveOptions]="{ exact: true }">Links</a>
                </li>
                <li class="menu-item">
                  <a [routerLink]="['about']" [routerLinkActive]="['current-menu-item']" [routerLinkActiveOptions]="{ exact: true }">About</a>
                </li>
              </ul>
            </div>
        </header>
        <div class="site-content">
          <router-outlet></router-outlet>
        </div>